const BjHeader = () => {

    return(
        <div className='titleHeader backgroundCorrect'>
            <h1>Black Jack</h1>
        </div>
    )
};

export default BjHeader;